import React, {
  ReactElement, ReactNode, useEffect, useMemo, useState,
} from 'react';
import { useLocation } from 'react-router';
import Context, { PodpisPredsedaFormDataContextContent } from './PodpisPredsedaFormDataContext';

interface Props {
  children: ReactNode;
}

const PodpisPredsedaFormDataContextProvider = ({ children }: Props): ReactElement => {
  const [obalMaterialuFormData, setObalMaterialuFormData] = useState(null);
  const [generatedFile, setGeneratedFile] = useState(null);
  const currentLocation = useLocation();

  useEffect(() => {
    if (!currentLocation.pathname.includes('podpis-predseda')) {
      setGeneratedFile(null);
      setObalMaterialuFormData(null);
    }
  }, [currentLocation]);

  const value: PodpisPredsedaFormDataContextContent = useMemo(() => ({
    obalMaterialuFormData,
    setObalMaterialuFormData,
    generatedFile,
    setGeneratedFile,
  }), [obalMaterialuFormData, setObalMaterialuFormData, generatedFile, setGeneratedFile]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default PodpisPredsedaFormDataContextProvider;
